import { ChangeDetectionStrategy, Component, Inject, Injector, Type } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from '../../helpers/modal.tokens';

export interface ModalPayload<C = unknown, D = unknown> {
  component: Type<C>;
  data?: D;
}

@Component({
  selector: 'app-modal-wrapper',
  template: `
    <div class="modal-wrapper">
      <ng-container
        *ngComponentOutlet="data.component; injector: injector">
      </ng-container>
    </div>
  `,
  styleUrls:['./modal-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalWrapperComponent {
  injector!: Injector;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalPayload,
    private dialogRef: MatDialogRef<ModalWrapperComponent>,
    parentInjector: Injector
  ) { 
    this.injector = Injector.create({
      providers: [
        {provide: MODAL_DATA, useValue: data.data},
        {provide: MatDialogRef, useValue: this.dialogRef}
      ],
      parent: parentInjector
    });
  }
  
  close(result?: any): void {
    this.dialogRef.close(result);
  }
}
